import { createScopedDescriptor } from '../../globalState/api';
import { getBuildTimePropertyNames } from '../../globalState/initialize';

// Properties initialized in quartz/globalState/initialize.ts
export const COPILOT_LAYOUT_TYPE = createScopedDescriptor(getBuildTimePropertyNames().copilotLayoutType, 'BROWSING_CONTEXT');
export const COPILOT_SIDEBAR_SIDE = createScopedDescriptor(getBuildTimePropertyNames().copilotSidebarSide, 'BROWSING_CONTEXT');